import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {CountryRestrictionSettingsConfig} from 'interfaces/common/components/countryrestriction/countryRestrictionSettingsConfig';

export const initCountryRestriction = (gemSettings: GemSettings) => () => {
    const countryRestriction = getGemSettingsFeature<CountryRestrictionSettingsConfig>(gemSettings, 'country-restriction');
    if (countryRestriction && gemSettings.wcmMode !== 'EDIT') {
        import(/* webpackChunkName: "checkCountryRestriction" */ 'app/components/countrySelection/checkCountryRestriction').then(
            ({checkCountryRestriction}) => {
                checkCountryRestriction(gemSettings);
            },
        );
    }
};
